import axios from 'axios';
import {toast} from 'react-toastify';
import * as Sentry from '@sentry/react';

class Api {
    axiosInstance = axios.create();
    origin = window.location.origin;

    constructor() {
        this.axiosInstance.interceptors.response.use(null, (error) => {
            const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

            if (!expectedError) {
                toast.error('Unexpected error occurred. This error has been logged for review by support staff. Email ttportal@bcit.ca if the error continues to persist.', {autoClose: false});
            } else {
                if (error.response.data?.error) toast.error(error.response.data?.error, {autoClose: false});
                else toast.error(error.response.data, {autoClose: false});
            }


            Sentry.captureException(error);
            return Promise.reject(error);
        });
    }

    async get(endPoint) {
        const {data} = await this.axiosInstance.get(`${this.origin}${endPoint}`);
        return data;
    }

    async insert(endPoint, item) {
        const {data, status} = await this.axiosInstance.post(endPoint, item);
        return {data: data, status: status};
    }

    async update(endPoint, item) {
        const {data, status} = await this.axiosInstance.put(endPoint, item);
        return {data: data, status: status};
    }

    async deleteByItem(endPoint, item) {
        const {status} = await this.axiosInstance.delete(endPoint, {data: item});
        return status;
    }

    async deleteById(endPoint, id, queryParams = {}) {
        const {status} = await this.axiosInstance.delete(`${endPoint}/${id}`, {
            params: queryParams
        });
        return status;
    }
}

export default Api;
